import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Account } from '../../../models/AccountModel';
import { PlatformApiService } from '../../../services/platform-api.service';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-percentile-graph-component',
  templateUrl: './percentile-graph-component.component.html',
  styleUrls: ['./percentile-graph-component.component.scss']
})
export class PercentileGraphComponentComponent implements OnInit {

  @ViewChild(BaseChartDirective, { static: true }) private _chart;

  @Input() graphTitle: string;
  @ViewChild('myCanvas', { static: true }) canvas: ElementRef;
  @Input() parentAccount: Account;
  @Input() groupingField: string;
  @Input() groupingValue: string;
  _highlightScore: number;
  percentiles: any;
  percentileCounts: any;

  constructor(private _platformApi: PlatformApiService) { }

  barColor = '#1a3047';
  highlightColor = '#5bba47';
  gradient = ['#e53a35','#D8A40A', '#5bba47'];

  public barChartOptions:any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
          scaleLabel: {
              display: true,
              labelString: 'Percentile'
          },
          gridLines: {
              display: false,
              drawTicks: false
          },
          ticks: {
              min: 0,
              max: 100,
              display: true
          }
      }],
      yAxes: [{
          scaleLabel: {
              display: true,
              labelString: '# Companies'
          },
          gridLines: {
              display: false,
              drawTicks: false
          },
          ticks: {
              display: false
          }
      }]
    },
  };
  public barChartLabels:string[] = [];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartColors:Array<any>;

  public barChartData:any[] = [
    {data: [], label: '# Companies'}
  ];

  @Input() set highlightScore(value) {
    this._highlightScore = value;
    if (this.percentiles) {
      this.barChartColors.length = 0;

      const colors = [];
      const highlightPercentile = this.getScorePercentile(this.percentiles, this._highlightScore);

      for (const bucket of this.percentileCounts as any) {
        if (bucket.percentile == highlightPercentile) {
          colors.push(this.highlightColor);
        } else {
          colors.push(this.barColor);
        }
      }
      this.barChartColors = [{backgroundColor: colors, hoverBackgroundColor: colors, hoverBorderColor: '#1a3047', hoverBorderWidth: 1}];
    }
  }

  ngOnInit() {
    this.loadBarChart();
  }

  loadBarChart() {
    const colors = [];
    const data = [];
    const labels = [];
    console.log('company size', this.groupingValue);
    this._platformApi.getPercentiles(undefined, undefined, this.groupingField, this.groupingValue).subscribe(percentiles => {
      this.percentiles = percentiles;
      this._platformApi.getPercentileCounts(null, null, this.groupingField, this.groupingValue).subscribe(percentileCounts => {
        this.percentileCounts = percentileCounts;
        const highlightPercentile = this.getScorePercentile(this.percentiles, this._highlightScore);
        for (const bucket of percentileCounts as any) {
          data.push(bucket.count);
          labels.push(bucket.percentile);
          if (bucket.percentile == highlightPercentile) {
            colors.push(this.highlightColor);
          } else {
            colors.push(this.barColor);
          }
        }
        this.barChartData[0].data = data;
        this.barChartData.slice();
        this.barChartColors = [{backgroundColor: colors, hoverBackgroundColor: colors, hoverBorderColor: '#1a3047', hoverBorderWidth: 1}];
        this.barChartColors.slice();
        this.barChartLabels = labels;
      })
    });
  }

  getScorePercentile(percentiles, score) {
    if (score == undefined) {
      return undefined;
    } else {
      const buckets = Object.keys(percentiles).reverse();
      const companyPerc = buckets.find(pel => score >= percentiles[pel])
      return companyPerc;
    }
  }

}
